<template>
  <section>
    <el-dialog
      :close-on-click-modal="false"
      :show-close="false"
      class="importDialog"
      :title="title"
      :visible.sync="innerShow"
      @open="handleDialogOpen"
      @opened="handleDialogOpened"
      width="500px"
    >
      <!-- 第1和第2所有上传统一，其他描述slot写入描述 -->
      <div v-show="state == 0" class="descClass">
        <span>请按以下步骤导入：</span>
        <br />
        <span>
          1、<span class="downLoadTmp" @click="downloadDemo">下载模板</span>
        </span>
        <br />
        <span>
          2、根据模板填写信息，上传填写后的Excel文件
        </span>
        <br />
        <slot name="desc"></slot>
      </div>
      <div v-show="state == 0">
        <el-upload
          name="file"
          style="width: 100%;"
          class="upload-demo"
          drag
          action=""
          :http-request="uploadFile"
          :show-file-list="false"
          :accept="uploaAccept"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            可直接拖拽文件到这里上传或
            <em>浏览文件</em>
          </div>
        </el-upload>
      </div>
      <div v-show="state == 1" style="padding: 25px 0">
        <el-row :gutter="20">
          <el-col :span="12" style="line-height: 50px;text-align: right;">
            文件正在上传
            <div class="el-loading-spinner" style="left: 40px;">
              <svg viewBox="25 25 50 50" class="circular">
                <circle
                  cx="50"
                  cy="50"
                  r="20"
                  fill="none"
                  class="path"
                ></circle>
              </svg>
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-show="state == 2" style="padding: 25px 0">
        <el-row :gutter="20">
          <el-col :span="15" style="line-height: 50px;text-align: right;"
            >文件上传完成，正在导入</el-col
          >
          <el-col :span="7">
            <el-progress
              :width="50"
              :stroke-width="4"
              type="circle"
              :percentage="precent"
            ></el-progress>
          </el-col>
        </el-row>
      </div>
      <div v-show="state == 3">
        <div class="importResult">
          <span>共识别到的数据：{{ displayTotal }}条</span>
          <br />
          <span>导入成功数量：{{ importInfo.successCount }}条</span>
          <span
            v-if="Number(importInfo.successCount) > 0"
            @click="downloadSuccessFile"
            class="downLoadErr mgLeft10"
          >
            下载成功数据
          </span>
          <br v-if="Number(importInfo.failCount) > 0" />
          <span v-if="Number(importInfo.failCount) > 0">
            导入失败数量：{{ importInfo.failCount }}条
          </span>
          <span
            v-if="Number(importInfo.failCount) > 0"
            @click="downloadFailFile"
            class="downLoadErr mgLeft10"
          >
            下载失败数据
          </span>
          <div
            v-if="successDetailList.length > 0"
            class="resultDetailBlock resultDetailBlock--success"
          >
            <p class="resultDetailTitle resultDetailTitle--success">成功提示：</p>
            <ul class="resultDetailList">
              <li
                v-for="(item, index) in successDetailList"
                :key="'success-' + index"
              >
                <span class="resultDetailMessage">{{ item.message }}</span>
              </li>
            </ul>
          </div>
          <div
            v-if="failDetailList.length > 0"
            class="resultDetailBlock resultDetailBlock--fail"
          >
            <p class="resultDetailTitle resultDetailTitle--fail">失败提示：</p>
            <ul class="resultDetailList">
              <li
                v-for="(item, index) in failDetailList"
                :key="'fail-' + index"
              >
                <span class="resultDetailMessage">{{ item.message }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-show="state == 0"
          @click="cancelDialog"
          size="small"
          style="font-size: 14px;"
        >
          取 消
        </el-button>
        <el-button
          v-show="state == 3"
          type="primary"
          @click="makeSure"
          size="small"
          style="font-size: 14px;"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
export default {
  name: "",
  props: {
    title: {
      type: String,
      default: "文件上传"
    },
    show: {
      type: Boolean,
      default: false
    },
    templateUrl: {
      type: String,
      default: ""
    },
    uploadUrl: {
      type: String,
      default: "/api/media/upload"
    },
    importUrl: {
      type: String,
      default: ""
    },
    progressUrl: {
      type: String,
      default: "/api/queue/admin/get_imexport_progress"
    },
    otherParams: {
      type: Object,
      default: () => {
        return {};
      }
    },
    downloadDemoName: {
      type: String,
      default: "导入模板"
    },
    downloadFailFileName: {
      type: String,
      default: "导入失败记录"
    },
    downloadSuccessFileName: {
      type: String,
      default: "导入成功记录"
    },
    uploaAccept: {
      type: String,
      default:".xlsx,.xls"
    }
  },
  data() {
    return {
      innerShow: this.show,
      importInfo: {
        total: 0,
        successCount: 0,
        failCount: 0,
        successFile: "",
        failFile: "",
        successDetails: [],
        failDetails: []
      },
      state: 0, // 0 - 未上传 1 - 上传中 2 -导入中 3-导入完成
      precent: 0,
      taskId: "",
      intervalClass: null
    };
  },
  computed: {
    displayTotal() {
      const total = Number(this.importInfo.total || 0);
      if (total > 0) {
        return total;
      }
      return Number(this.importInfo.successCount || 0) + Number(this.importInfo.failCount || 0);
    },
    successDetailList() {
      const details = Array.isArray(this.importInfo.successDetails) ? this.importInfo.successDetails : [];
      return details
        .map(item => {
          if (typeof item === "string") {
            return { message: item };
          }
          const summary = String((item || {}).summary || "").trim();
          const message = String((item || {}).message || "").trim();
          if (message) {
            return { ...item, message };
          }
          if (summary) {
            return { ...item, message: `${summary} 导入成功。` };
          }
          return null;
        })
        .filter(Boolean);
    },
    failDetailList() {
      const details = Array.isArray(this.importInfo.failDetails) ? this.importInfo.failDetails : [];
      return details
        .map(item => {
          if (typeof item === "string") {
            return { message: item };
          }
          const message = String((item || {}).message || "").trim();
          if (message) {
            return { ...item, message };
          }
          const row = String((item || {}).row || "").trim();
          const reason = String((item || {}).reason || "").trim();
          if (row && reason) {
            return { ...item, message: `${row} 失败：${reason}` };
          }
          if (reason) {
            return { ...item, message: reason };
          }
          return null;
        })
        .filter(Boolean);
    }
  },
  methods: {
    normalizeImportResult(rawResult) {
      const parsedRoot = this.parsePossibleJson(rawResult);
      const parsedFileInfo = this.parsePossibleJson(
        (parsedRoot && (parsedRoot.file_info || parsedRoot.fileInfo || parsedRoot.result_file_info)) || {}
      );
      return {
        ...(parsedFileInfo && typeof parsedFileInfo === "object" ? parsedFileInfo : {}),
        ...(parsedRoot && typeof parsedRoot === "object" ? parsedRoot : {})
      };
    },
    parsePossibleJson(value) {
      if (!value) {
        return {};
      }
      if (typeof value === "string") {
        try {
          return JSON.parse(value);
        } catch (error) {
          return {};
        }
      }
      return value && typeof value === "object" ? value : {};
    },
    uploadFile(req) {
      // this.state = 2;
      const data = new FormData();
      data.append("file", req.file);
      this.$common
        .http({
          url: this.uploadUrl,
          file: data,
          noLoading: true
        })
        .then(res => {
          this.$common
            .http({
              url: this.importUrl,
              data: Object.assign(this.otherParams, { file: res.data.data }),
              // retuenReject: true
            })
            .then(res1 => {
              this.$common.http({
                url: '/api/cron/imexport',
                noLoading: true,
                retuenReject: true
              });
              if (!(res1.data.data && res1.data.data.task_id)) {
                this.state = 0;
                return;
              }
              this.state = 2;
              this.taskId = res1.data.data.task_id;
              this.intervalClass = setInterval(() => {
                this.$common
                  .http({
                    method: "post",
                    url: this.progressUrl,
                    data: {
                      task_id: this.taskId
                    },
                    noLoading: true
                  })
                  .then(res2 => {
                    // 显示进度
                    this.precent = res2.data.data.percent;
                    if (res2.data.data.finish == 1) {
                      window.clearInterval(this.intervalClass);
                      setTimeout(() => {
                        const normalizedResult = this.normalizeImportResult(res2.data.data.result);
                        this.state = 3;
                        this.importInfo = {
                          total: normalizedResult.total || 0,
                          successCount: normalizedResult.success_total || 0,
                          failCount: normalizedResult.fail_total || 0,
                          successFile: normalizedResult.success_file || "",
                          failFile: normalizedResult.fail_file || "",
                          successDetails: normalizedResult.success_details || normalizedResult.successDetails || [],
                          failDetails: normalizedResult.fail_details || normalizedResult.failDetails || []
                        };
                        if (res2.data.data.remark) {
                          this.$message.warning(res2.data.data.remark);
                        }
                        this.$emit('finish');
                      }, 1000);
                      // 显示结果
                    }
                  });
              }, 1000);
            });
        });
    },
    makeSure() {
      this.$emit("update:show", false);
      this.$emit("callback");
      setTimeout(() => {
        this.state = 0;
      }, 2000);
    },
    downloadDemo() {
      this.$common.httpLoadFile({
        url: this.templateUrl,
        downloadName: this.downloadDemoName
      });
    },
    cancelDialog() {
      this.$emit("update:show", false);
    },
    downloadFailFile() {
      this.$common.httpLoadFile({
        url: this.importInfo.failFile,
        downloadName: this.downloadFailFileName
      });
    },
    downloadSuccessFile() {
      this.$common.httpLoadFile({
        url: this.importInfo.successFile,
        downloadName: this.downloadSuccessFileName
      });
    },
    // #region debug-point E:dialog-open
    handleDialogOpen() {
      window.fetch("http://127.0.0.1:7777/event", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ sessionId: "railway-import-unavailable", runId: "pre-fix", hypothesisId: "E", location: "myUploadNew/index.vue:handleDialogOpen", msg: "[DEBUG] child dialog open", data: { show: this.show, title: this.title, wrapperCount: document.querySelectorAll(".el-dialog__wrapper").length, importDialogCount: document.querySelectorAll(".importDialog").length }, ts: Date.now() }) }).catch(() => {});
    },
    handleDialogOpened() {
      window.fetch("http://127.0.0.1:7777/event", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ sessionId: "railway-import-unavailable", runId: "pre-fix", hypothesisId: "E", location: "myUploadNew/index.vue:handleDialogOpened", msg: "[DEBUG] child dialog opened", data: { show: this.show, title: this.title, wrapperCount: document.querySelectorAll(".el-dialog__wrapper").length, importDialogCount: document.querySelectorAll(".importDialog").length }, ts: Date.now() }) }).catch(() => {});
    }
    // #endregion
  },
  components: {},
  created() {},
  mounted() {},
  watch: {
    // #region debug-point E:child-show-watch
    show(val) {
      this.innerShow = val;
      window.fetch("http://127.0.0.1:7777/event", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ sessionId: "railway-import-unavailable", runId: "pre-fix", hypothesisId: "E", location: "myUploadNew/index.vue:show", msg: "[DEBUG] child show changed", data: { show: val, title: this.title, templateUrl: this.templateUrl, importUrl: this.importUrl }, ts: Date.now() }) }).catch(() => {});
    },
    innerShow(val) {
      if (val !== this.show) {
        this.$emit("update:show", val);
      }
    }
    // #endregion
  }
};
</script>
<style lang="less">
.importDialog {
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-upload,
  .el-upload-dragger {
    width: 100%;
  }

  .descClass {
    line-height: 30px;
    margin-bottom: 15px;
  }

  .downLoadTmp {
    text-decoration: underline;
    color: #409eff;
    cursor: pointer;
  }
  .mgLeft10 {
    margin-left: 10px;
  }
  .downLoadErr {
    text-decoration: underline;
    color: #fb687d;
    cursor: pointer;
  }
  .mgLeft10 {
    margin-left: 10px;
  }
  .importResult {
    line-height: 30px;
    > span {
      display: inline-block;
    }
  }
  .resultDetailBlock {
    margin-top: 12px;
    border-top: 1px solid #eee;
    padding-top: 8px;
    .resultDetailTitle {
      font-weight: bold;
      margin-bottom: 6px;
    }
    .resultDetailList {
      list-style: none;
      padding: 0;
      margin: 0;
      max-height: 200px;
      overflow-y: auto;
      li {
        padding: 4px 0;
        border-bottom: 1px dashed #f0f0f0;
        line-height: 1.6;
        &:last-child {
          border-bottom: none;
        }
      }
    }
    .resultDetailMessage {
      font-size: 12px;
      word-break: break-all;
    }
  }
  .resultDetailBlock--success {
    .resultDetailTitle--success,
    .resultDetailMessage {
      color: #67c23a;
    }
  }
  .resultDetailBlock--fail {
    .resultDetailTitle--fail {
      color: #e6a23c;
    }
    .resultDetailMessage {
      color: #f56c6c;
    }
  }
}
</style>
